import React from 'react';

import { Container } from './styles';

function Post({ title, image, className }) {
  return (
    <Container className={className} src={image}>
      <div className="img" />
      <h5 className="title">{title}</h5>
    </Container>
  );
}

export default Post;
